export const sender = [
  {
    address: "广东省广州市番禺区青蓝街**号",
    index: 1437712216269787136,
    phone: "180******91",
    sender: "维尼",
  },
];
